(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ch-sale-resources"] && !Shopify.designMode) return;
  try {
    function chUpdateSaleCountdowns(){
 if(document.hidden)return;
 const now=Date.now();
 document.querySelectorAll('[data-ch-sale-countdown]').forEach(timer=>{
  const raw=timer.dataset.end||'';
  const end=/([zZ]|[+-]\d{2}:\d{2})$/.test(raw)?Date.parse(raw):NaN;
  const seconds=Math.floor((end-now)/1000);
  if(!Number.isFinite(seconds)||seconds<=0){timer.hidden=true;return;}
  const days=Math.floor(seconds/86400),hours=Math.floor(seconds%86400/3600),minutes=Math.floor(seconds%3600/60),rest=seconds%60;
  const pad=value=>String(value).padStart(2,'0');
  const text=`${pad(days)} ${timer.dataset.day} ${pad(hours)}:${pad(minutes)}:${pad(rest)}`;
  const value=timer.querySelector('[data-ch-countdown-value]');
  if(value&&value.textContent!==text)value.textContent=text;
  timer.hidden=false;
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',chUpdateSaleCountdowns);else chUpdateSaleCountdowns();
document.addEventListener('shopify:section:load',chUpdateSaleCountdowns);
document.addEventListener('visibilitychange',chUpdateSaleCountdowns);
setInterval(chUpdateSaleCountdowns,1000);
  } catch(e) { console.error(e); }
})();

})();
